import React from "react";
import { useTranslation } from "react-i18next";

import Title from "components/common/Layout/Title";
import FormRow from "components/common/Layout/FormRow";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import { MODE_TRANSPORT } from "constants/transport";

import {
    numberInput,
    floatNormalize50,
    floatNormalize9999,
} from "components/InputsField/inputFormats";

const TransportSizes = ({ mode = MODE_TRANSPORT.transport }) => {
    const { t } = useTranslation();

    return (
        <>
            <Title withMargin>{t("transportFields.vehicle_size_section.heading")}</Title>
            <FormRow>
                <FormRow>
                    <FormRow withSpace>
                        <FormikTextField
                            name="length"
                            label={t("transportFields.vehicle_size_section.length")}
                            maxLength="4"
                            placeholder=""
                            format={numberInput}
                            normalize={floatNormalize50}
                        />
                        <FormikTextField
                            label={t("transportFields.vehicle_size_section.width")}
                            name="width"
                            maxLength="4"
                            placeholder=""
                            format={numberInput}
                            normalize={floatNormalize50}
                        />
                    </FormRow>
                    <FormRow withSpace>
                        <FormikTextField
                            name="height"
                            label={t("transportFields.vehicle_size_section.height")}
                            maxLength="4"
                            placeholder=""
                            format={numberInput}
                            normalize={floatNormalize50}
                        />
                        <FormikTextField
                            label={t("transportFields.vehicle_size_section.capacity")}
                            name="volume"
                            maxLength="6"
                            placeholder=""
                            format={numberInput}
                            normalize={floatNormalize9999}
                        />
                    </FormRow>
                </FormRow>
            </FormRow>
            <FormRow withMargin>
                <FormRow withSpace>
                    <FormikTextField
                        label={t("transportFields.vehicle_size_section.weight")}
                        name="carrying_capacity"
                        maxLength="6"
                        placeholder=""
                        format={numberInput}
                        normalize={floatNormalize9999}
                    />
                    <></>
                </FormRow>
                <></>
            </FormRow>
            {mode === MODE_TRANSPORT.exchange && (
                <FormRow withMargin>
                    <FormikCheckboxField
                        name="partial_load"
                        id="partial_load"
                        label={t("transportFields.body_section.backloading")}
                    />
                </FormRow>
            )}
        </>
    );
};

export default TransportSizes;
